import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7a632130 = () => interopDefault(import('../pages/ban-hang-doanh-nghiep.vue' /* webpackChunkName: "pages/ban-hang-doanh-nghiep" */))
const _21b82936 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _4e1cb942 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _76875f80 = () => interopDefault(import('../pages/category/index.vue' /* webpackChunkName: "pages/category/index" */))
const _bcbf19a8 = () => interopDefault(import('../pages/chinh-sach-ban-hang.vue' /* webpackChunkName: "pages/chinh-sach-ban-hang" */))
const _d4100868 = () => interopDefault(import('../pages/chinh-sach-bao-hanh.vue' /* webpackChunkName: "pages/chinh-sach-bao-hanh" */))
const _cf6d2f70 = () => interopDefault(import('../pages/chinh-sach-bao-ve.vue' /* webpackChunkName: "pages/chinh-sach-bao-ve" */))
const _138e6ccd = () => interopDefault(import('../pages/chinh-sach-kiem-hang.vue' /* webpackChunkName: "pages/chinh-sach-kiem-hang" */))
const _48db026c = () => interopDefault(import('../pages/chinh-sach-thanh-toan.vue' /* webpackChunkName: "pages/chinh-sach-thanh-toan" */))
const _3a178c4f = () => interopDefault(import('../pages/chinh-sach-van-chuyen-giao-nhan.vue' /* webpackChunkName: "pages/chinh-sach-van-chuyen-giao-nhan" */))
const _bac7a940 = () => interopDefault(import('../pages/collection/index.vue' /* webpackChunkName: "pages/collection/index" */))
const _281204b2 = () => interopDefault(import('../pages/dieu-khoan-su-dung-chinh-sach-bao-mat.vue' /* webpackChunkName: "pages/dieu-khoan-su-dung-chinh-sach-bao-mat" */))
const _11cd6b36 = () => interopDefault(import('../pages/error_page.vue' /* webpackChunkName: "pages/error_page" */))
const _7b3a5a13 = () => interopDefault(import('../pages/gioi-thieu.vue' /* webpackChunkName: "pages/gioi-thieu" */))
const _c6ded6ce = () => interopDefault(import('../pages/my_account.vue' /* webpackChunkName: "pages/my_account" */))
const _55979d67 = () => interopDefault(import('../pages/not_found.vue' /* webpackChunkName: "pages/not_found" */))
const _5b0452e4 = () => interopDefault(import('../pages/orders.vue' /* webpackChunkName: "pages/orders" */))
const _08d2e064 = () => interopDefault(import('../pages/quy-dinh-mua-ban.vue' /* webpackChunkName: "pages/quy-dinh-mua-ban" */))
const _028a3c27 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _73440042 = () => interopDefault(import('../pages/shipping-policy.vue' /* webpackChunkName: "pages/shipping-policy" */))
const _14525ff0 = () => interopDefault(import('../pages/thong-tin-lien-he.vue' /* webpackChunkName: "pages/thong-tin-lien-he" */))
const _bdcf4ab6 = () => interopDefault(import('../pages/blogs/search.vue' /* webpackChunkName: "pages/blogs/search" */))
const _67539b0a = () => interopDefault(import('../pages/product/favorite.vue' /* webpackChunkName: "pages/product/favorite" */))
const _158d7ed0 = () => interopDefault(import('../pages/product/old.vue' /* webpackChunkName: "pages/product/old" */))
const _512f1624 = () => interopDefault(import('../pages/checkout/success/_id.vue' /* webpackChunkName: "pages/checkout/success/_id" */))
const _25256bc6 = () => interopDefault(import('../pages/blogs/_slug.vue' /* webpackChunkName: "pages/blogs/_slug" */))
const _74d0be38 = () => interopDefault(import('../pages/category/_slug.vue' /* webpackChunkName: "pages/category/_slug" */))
const _77c8e6c2 = () => interopDefault(import('../pages/checkout/_code.vue' /* webpackChunkName: "pages/checkout/_code" */))
const _7bfd85c8 = () => interopDefault(import('../pages/collection/_id.vue' /* webpackChunkName: "pages/collection/_id" */))
const _bc91faaa = () => interopDefault(import('../pages/product/_id.vue' /* webpackChunkName: "pages/product/_id" */))
const _8b92092a = () => interopDefault(import('../pages/san-pham/_slug.vue' /* webpackChunkName: "pages/san-pham/_slug" */))
const _240df9ed = () => interopDefault(import('../pages/store/_slug.vue' /* webpackChunkName: "pages/store/_slug" */))
const _0b0ed1a3 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _39b59f30 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ban-hang-doanh-nghiep",
    component: _7a632130,
    name: "ban-hang-doanh-nghiep"
  }, {
    path: "/blogs",
    component: _21b82936,
    name: "blogs"
  }, {
    path: "/cart",
    component: _4e1cb942,
    name: "cart"
  }, {
    path: "/category",
    component: _76875f80,
    name: "category"
  }, {
    path: "/chinh-sach-ban-hang",
    component: _bcbf19a8,
    name: "chinh-sach-ban-hang"
  }, {
    path: "/chinh-sach-bao-hanh",
    component: _d4100868,
    name: "chinh-sach-bao-hanh"
  }, {
    path: "/chinh-sach-bao-ve",
    component: _cf6d2f70,
    name: "chinh-sach-bao-ve"
  }, {
    path: "/chinh-sach-kiem-hang",
    component: _138e6ccd,
    name: "chinh-sach-kiem-hang"
  }, {
    path: "/chinh-sach-thanh-toan",
    component: _48db026c,
    name: "chinh-sach-thanh-toan"
  }, {
    path: "/chinh-sach-van-chuyen-giao-nhan",
    component: _3a178c4f,
    name: "chinh-sach-van-chuyen-giao-nhan"
  }, {
    path: "/collection",
    component: _bac7a940,
    name: "collection"
  }, {
    path: "/dieu-khoan-su-dung-chinh-sach-bao-mat",
    component: _281204b2,
    name: "dieu-khoan-su-dung-chinh-sach-bao-mat"
  }, {
    path: "/error_page",
    component: _11cd6b36,
    name: "error_page"
  }, {
    path: "/gioi-thieu",
    component: _7b3a5a13,
    name: "gioi-thieu"
  }, {
    path: "/my_account",
    component: _c6ded6ce,
    name: "my_account"
  }, {
    path: "/not_found",
    component: _55979d67,
    name: "not_found"
  }, {
    path: "/orders",
    component: _5b0452e4,
    name: "orders"
  }, {
    path: "/quy-dinh-mua-ban",
    component: _08d2e064,
    name: "quy-dinh-mua-ban"
  }, {
    path: "/search",
    component: _028a3c27,
    name: "search"
  }, {
    path: "/shipping-policy",
    component: _73440042,
    name: "shipping-policy"
  }, {
    path: "/thong-tin-lien-he",
    component: _14525ff0,
    name: "thong-tin-lien-he"
  }, {
    path: "/blogs/search",
    component: _bdcf4ab6,
    name: "blogs-search"
  }, {
    path: "/product/favorite",
    component: _67539b0a,
    name: "product-favorite"
  }, {
    path: "/product/old",
    component: _158d7ed0,
    name: "product-old"
  }, {
    path: "/checkout/success/:id?",
    component: _512f1624,
    name: "checkout-success-id"
  }, {
    path: "/blogs/:slug",
    component: _25256bc6,
    name: "blogs-slug"
  }, {
    path: "/category/:slug",
    component: _74d0be38,
    name: "category-slug"
  }, {
    path: "/checkout/:code?",
    component: _77c8e6c2,
    name: "checkout-code"
  }, {
    path: "/collection/:id",
    component: _7bfd85c8,
    name: "collection-id"
  }, {
    path: "/product/:id?",
    component: _bc91faaa,
    name: "product-id"
  }, {
    path: "/san-pham/:slug?",
    component: _8b92092a,
    name: "san-pham-slug"
  }, {
    path: "/store/:slug?",
    component: _240df9ed,
    name: "store-slug"
  }, {
    path: "/",
    component: _0b0ed1a3,
    name: "index"
  }, {
    path: "/*",
    component: _39b59f30,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
